import {Checkbox, Modal} from '@mantine/core';
import type React from 'react';
import {MdChevronRight, MdClose, MdEvent} from 'react-icons/md';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {buildScheduleGtmContent} from '../../../../../shared/services/buildScheduleGtmContent';
import {ScheduleButtonNewDesign} from '../../../../recruitment/components/ScheduleButton';

type Props = {
  opened: boolean;
  onClose: () => void;
  recruitmentId: number;
  recruitmentTitle: string;
  scheduleId: number;
  isCalendarRegistered: boolean;
  calendarRegisteredCount: number;
  companyId: number;
  companyName: string;
  detailURL: string;
  pagePath: string;
  suppressChecked: boolean;
  onSuppressChange: (checked: boolean) => void;
};

export const FollowCompletionModal: React.FC<Props> = ({
  opened,
  onClose,
  recruitmentId,
  recruitmentTitle,
  scheduleId,
  isCalendarRegistered,
  calendarRegisteredCount,
  companyId,
  companyName,
  detailURL,
  pagePath,
  suppressChecked,
  onSuppressChange,
}) => {
  const gtmContent = JSON.stringify({
    recruitment_id: recruitmentId,
    company_id: companyId,
    company_name: companyName,
    page_path: pagePath,
  });
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      withCloseButton={false}
    >
      <div className="flex flex-col gap-16 pb-8">
        <button
          type="button"
          aria-label="閉じる"
          onClick={onClose}
          className="self-start text-black-2 hover:opacity-70"
        >
          <MdClose size={20} />
        </button>
        <div className="flex justify-center">
          <MdEvent size={42} className="text-primary-1" />
        </div>
        <p className="text-xl font-bold text-black-1 text-center">
          フォローが完了しました！
        </p>
        <div>
          <p className="text-base font-bold text-black-1">{recruitmentTitle}</p>
          <p className="text-sm font-bold text-black-1 text-center mt-12">
            の予定を追加しましょう
          </p>
        </div>
        <p className="text-xs text-black-2">
          予定を追加するとリマインドなどの情報が通知されます
        </p>
        <ScheduleButtonNewDesign
          scheduleId={scheduleId}
          isRegisteredInitial={isCalendarRegistered}
          registeredCountInitial={calendarRegisteredCount}
          buttonStyle="primary"
          recruitmentData={{
            companyId,
            companyName,
            entryTitle: recruitmentTitle,
            detailURL,
          }}
          dataGtmClick="recruitment-schedule-add"
          dataGtmContent={buildScheduleGtmContent({
            scheduleId,
            location: 'recruiting-info-follow-completion-modal',
          })}
        />
        <CommonLink
          href="/recruiting_info"
          className="flex items-center text-sm font-bold text-primary hover:opacity-70"
          data-gtm-click="recruitment-follow-completion-view-list"
          data-gtm-content={gtmContent}
        >
          募集情報一覧をみる
          <MdChevronRight size={18} />
        </CommonLink>
        <hr className="border-line" />
        <Checkbox
          label="しばらくこのメッセージを表示しない"
          checked={suppressChecked}
          onChange={(e) => onSuppressChange(e.currentTarget.checked)}
          size="sm"
          data-gtm-click="recruitment-follow-completion-suppress"
          data-gtm-content={gtmContent}
        />
      </div>
    </Modal>
  );
};
